import type { FC } from 'react'

import css from '../List.css'

type ListItemDateProps = {
  date: Date | string
}

const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
  hour12: false,
})

function formatDate(date: Date | string): string {
  const parsedDate = new Date(date)
  return dateFormatter.format(parsedDate).replace('.,', '')
}

export const ListItemDate: FC<ListItemDateProps> = ({ date }) => {
  return <span className={css.primary}>{formatDate(date)}</span>
}
